module.exports = __webpack_public_path__ + "img/KPMG_logo.7e233d79.png";